import React from "react";
import {
    AppBar,
    Toolbar,
    Typography,
    Grid,
    Link,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import logo from "../wtw_new_logo_color.svg";
import useTranslation from "../application/translation";

const useStyles = makeStyles((theme) => ({
    topAppBar: {
        height: "auto",
        minHeight: "200px",
        marginBottom: "10px",
    },
    toolbar: {
        alignItems: "flex-start",
        justifyContent: "center",
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },
    logo: {
        height: 25,
        marginBottom: theme.spacing(1),
    },
    title: {
        flexGrow: 1,
        alignSelf: "flex-end",
        verticalAlign: "middle",
        display: "inline-flex",
    },
    item: {
        alignSelf: "center",
    },
    link: {
        marginLeft: theme.spacing(0.5),
    },
}));

const AppBars = () => {
    const styles = useStyles();
    const translation = useTranslation();

    return (
        <header>
            <AppBar
                role="banner"
                position="static"
                elevation={0}
                color="default"
                className={styles.topAppBar}
            >
                <Toolbar className={styles.toolbar}>
                    <Grid container direction="row" alignItems="center">
                        <Grid item xs={12}>
                            <img
                                className={styles.logo}
                                src={logo}
                                alt="Willis Towers Watson logo"
                            />
                        </Grid>

                        <Grid container item xs={12} className={styles.item} spacing={1}>
                            <Grid item xs={12}>
                                <Typography variant="caption" color="primary">
                                    Willis Towers Watson Sweden AB
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="caption" color="primary">
                                    <Link
                                        href={`tel:${translation.startpage_phonenr}`}
                                        aria-label={`Ring ${translation.startpage_phonenr}`}
                                    >
                                        Tel: {translation.startpage_phonenr}
                                    </Link>
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="caption" color="primary">
                                    <Link
                                        href={`mailto:${translation.startpage_email}`}
                                        aria-label={`Skicka e-post till ${translation.startpage_email}`}
                                    >
                                        E-post: {translation.startpage_email}
                                    </Link>
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>
        </header>
    );
};

export default AppBars;
